import React from 'react'
import { css } from '@emotion/css'
import { useIntl } from 'react-intl'
import isNumber from 'lodash/isNumber'
import { Text } from '@contrast-security-inc/design-system-typography'
import { Library } from '../../helpers/ui-interfaces'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { IconInformation } from '@contrast-security-inc/design-system-foundations'
import { Stack } from '@contrast-security-inc/design-system-layouts'

const epssTitleCss = css`
  margin-bottom: 16px;
`
const epssContainerCss = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const epssItemCss = css`
  height: 34px;
  display: flex;
  align-items: center;
`

export const EPSSList = ({ library }: { library: Library }) => {
  const { formatMessage, formatPlural } = useIntl()
  const intl = useIntl()

  return (
    <div>
      <Stack>
        <Text as="div" className={epssTitleCss} font="titleH5">
          {formatMessage({ id: 'title_libraries_epss' })}
        </Text>
        <Tooltip body={intl.formatMessage({ id: 'detail_epssTooltip' })}>
          <IconInformation
            size="sm"
            color="neutral60"
            className={css`
              margin-top: 4px;
              margin-left: -4px;
            `}
          />
        </Tooltip>
      </Stack>
      <div className={epssContainerCss}>
        {library.vulnerabilities.map((vuln, index) => (
          <div className={epssItemCss} key={`epss-item-${vuln.name}-${index}`}>
            {isNumber(vuln.epssScore) && isNumber(vuln.epssPercentile) ? (
              <Text font="body">
                <Text font="bodyStrong">{vuln.epssScore}</Text>
                {' ('}
                {formatMessage(
                  {
                    id: `title_libraries_percentile_ordinal_${formatPlural(
                      vuln.epssPercentile,
                      { type: 'ordinal' }
                    )}`
                  },
                  { count: vuln.epssPercentile }
                )}
                {') '}
                <Text font="bodyStrong">
                  {vuln.cisa
                    ? formatMessage({ id: 'title_libraries_knownExploit' })
                    : null}
                </Text>
              </Text>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  )
}
